// extracted by mini-css-extract-plugin
export var body = "_fx-5";
export var closeButton = "_fx-f";
export var container = "_fx-1";
export var content = "_fx-2";
export var cta = "_fx-c";
export var ctaLabel = "_fx-b";
export var eyebrow = "_fx-3";
export var howTo = "_fx-6";
export var image = "_fx-e";
export var modal = "_fx-0";
export var socialButton = "_fx-d";
export var stepCard = "_fx-8";
export var stepLabel = "_fx-a";
export var stepNumber = "_fx-9";
export var steps = "_fx-7";
export var title = "_fx-4";